<template>
  <div id="second-level">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SecondLevel",
  components: {}
};
</script>

<style lang="scss" scoped>
#second-level {
  .title {
    margin: 35px 0;
    line-height: 30px;
    .chinese {
      color: #2e96ea;
      font-size: 24px;
    }
    .inner {
      display: flex;
      align-items: center;
      .english {
        color: #c2c2c2;
        font-size: 24px;
        white-space: nowrap;
      }
      .line {
        display: inline-block;
        width: 100%;
        height: 1px;
        background: #d2d2d2;
        margin-left: 5px;
      }
    }
  }
}
</style>
